<template>
  <div>
    <AdminHeader></AdminHeader>
    <section class="admin-back">
      <div class="top">
        <div class="back_order">
          <i class="fa fa-angle-left"></i>
          <router-link to="/admin/orderList">返回訂單總覽</router-link>
        </div>
        <div class="release_news">
          <router-link to="/admin/create_news"><button class="release_news">發布新消息</button></router-link>
        </div>
      </div>
      <div v-if="isNoNews">目前無任何新聞消息供顯示</div>
      <div class="news" v-else-if="newsInfo">
        <router-link :to="{ name:'admin_edit_news', params: {id:news.id} }" class="news_item" tag="div" v-for="news in newsInfo" :key="news.id">
          <div class="news_top">
            <div class="news_title">{{news.title}}</div>
            <div class="news_date">{{news.created_at}}</div>
          </div>
          <pre class="news_content">{{news.body}}</pre>
        </router-link>
      </div>
      <div class="load" v-else>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </section>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/admin_header.vue";
import axios from "axios";

export default {
  name: "admin_latest_newsList",
  components: {
    AdminHeader
  },
  data() {
    return {
      newsInfo: "",
      isNoNews: false
    };
  },
  created() {
    this.getNewsInfo();
  },
  methods: {
    getNewsInfo() {
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/news?number=all",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => {
          this.newsInfo = response.data.data;
          if (this.newsInfo.length == 0) {
            this.isNoNews = true;
          }
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    }
  }
};
</script>

<style scoped lang="scss">
* {
  color: #4a4a4a;
  font-size: 17px;
}
.admin-back {
  display: grid;
  align-items: center;
  margin: 0 30px;
  .top {
    display: flex;
    margin-top: 30px;
  }
  i {
    color: $secondaryDeepColor1;
    margin-right: 10px;
  }
  .release_news {
    letter-spacing: 1px;
    color: $secondaryColor3;
    background-color: #4a90e2;
    width: 120px;
    height: 35px;
    margin-left: auto;
    &:hover {
      background-color: darken(#4a90e2, 10%);
    }
  }
}
.news {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 50px;
  .news_item {
    padding: 20px;
    border: 1px#a8894c solid;
    margin: 5px;
    width: 390px;
    height: 140px;
    cursor: pointer;
    &:hover {
      background-color: #f5f0e4;
    }
    .news_top {
      display: flex;
    }
    .news_title {
      font-weight: bold;
      letter-spacing: 1px;
      max-width: 300px;
      text-align: justify;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .news_date {
      margin-left: auto;
    }
    .news_content {
      width: 100%;
      max-width: 390px;
      line-height: 1.5;
      margin: 1em 0;
      text-align: justify;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
    }
  }
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
